












































import { defineComponent, getCurrentInstance, ref, watch } from "vue";
import { mapActions } from "vuex";

export default defineComponent({
  props: {
    ticket: {
      type: String,
      default: ""
    },
    type: {
      type: Number,
      required: true
    },
    step: {
      type: String,
      required: true
    }
  },
  emits: ["wasEvaluated"],
  methods: {
    ...mapActions("ticket", ["saveExpRating"])
  },
  setup(props, { emit }) {
    const observation = ref("");
    const selectedRate = ref<number>();
    const context = getCurrentInstance().proxy;

    watch([observation, selectedRate], ([_observation, _selectedRate]) => {
      if (_selectedRate && _selectedRate >= 3) {
        emit("wasEvaluated", true);
        return;
      }

      if (_selectedRate && _selectedRate < 3 && _observation.length) {
        emit("wasEvaluated", true);
        return;
      }

      emit("wasEvaluated", false);
    });

    const sendAvaliation = async () => {
      context.$root.$emit("show-loading");
      await context["saveExpRating"]({
        ticket: props.ticket,
        type: props.type,
        step: props.step,
        acknowledged: true,
        rating: selectedRate.value,
        obs: observation.value,
        responses: []
      });
      context.$root.$emit("hide-loading");
    };

    return {
      observation,
      selectedRate,
      sendAvaliation
    };
  }
});
